<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con red">{{ dataItem.createdate }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单创建人：</p>
            <p class="con flex-rowl">{{ dataItem.username }} <a :href="'tel:'+dataItem.linkphone" class="flex-rowl phone-icon"><span class="iconfont icon-24gl-phoneLoudspeaker"></span></a></p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">取件类型：</p>
            <p class="con">
              {{ dataItem.get_sitein == 2 ? "园区外" : "园区内" }}
            </p>
          </div>
          <div class="column flex-rowl" v-if="dataItem.get_sitein == 2">
            <p class="label">取件地址：</p>
            <p class="con">
              {{ dataItem.province }}{{ dataItem.city }}{{ dataItem.area }}
              {{ dataItem.address }}
            </p>
          </div>
          <div class="column flex-rowl" v-else>
            <p class="label">取件地址：</p>
            <p class="con">
              {{ dataItem.getyuanqu }}{{ dataItem.get_parameteridstr
              }}{{ dataItem.get_buildingidstr }}{{ dataItem.get_addr }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取件人信息：</p>
            <p class="con flex-rowl">{{ dataItem.get_truename }} <a :href="'tel:'+dataItem.getlinkphone" class="flex-rowl phone-icon"><span class="iconfont icon-24gl-phoneLoudspeaker"></span></a></p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">收件地址：</p>
            <p class="con">{{ dataItem.takeyuanqu }}{{ dataItem.take_parameteridstr }}{{ dataItem.take_buildingidstr }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">收件人信息：</p>
            <p class="con flex-rowl">{{ dataItem.give_truename }} <a :href="'tel:'+dataItem.givelinkphone" class="flex-rowl phone-icon"><span class="iconfont icon-24gl-phoneLoudspeaker"></span></a></p>
          </div>
        </div>

        <div class="block_two">
          <div class="column">
            <p class="label tit">物件信息</p>
            <p class="label">重量：{{ dataItem.weight }}</p>
          </div>
          <div class="column column_img flex-rowl">
            <div
              class="cloumn_item"
              v-for="(item, index) in dataItem.givepicArr"
              :key="index"
              @click="handlePreview(index)"
            >
              <van-image width="100%" height="100" :src="item" />
            </div>
          </div>
        </div>
        <div class="block_two">备注：{{ dataItem.ordernote }}</div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">服务费用：</p>
            <p class="con red" v-if="dataItem.fee_standardstr">
              ¥{{ dataItem.fee_standardstr }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">打赏费用：</p>
            <p class="con">
              ¥{{ dataItem.prizenum }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">收费共计：</p>
            <p class="con">
              ¥{{ dataItem.price}}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">确认码：</p>
            <p class="con">{{ dataItem.pick_code }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单分配：</p>
            <p class="con red">
              {{ dataItem.distri_status == 1 ? "已分配" : "待分配" }}
            </p>
          </div>
          <div class="column" v-if="dataItem.distri_status != 1">
            <p class="label">分配给：</p>
            <div class="select_box flex-rowl" @click="isShow = true">
              <p>
                {{
                  distriInfo.delivery_staff_name
                    ? distriInfo.delivery_staff_name
                    : "请选择"
                }}
              </p>
              <span class="iconfont icon-yuyinjiantou"></span>
            </div>
          </div>
          <div class="column flex-rowl" v-if="dataItem.distri_status == 1">
            <p class="label">跑腿业务员：</p>
            <p class="con red">{{ distriInfo.delivery_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">服务进度：</p>
            <p class="con">{{ dataItem.server_statestr }}</p>
          </div>
        </div>
        
        <div class="block_two">
          <div
            class="custom_btn isDisabled"
            @click="handleSubmit"
            v-if="dataItem.server_state >= 2"
          >重新派单</div>
          <div
            v-else
            class="custom_btn"
            :class="{ isDisabled: isSubmitting }"
            @click="handleSubmit"
          >
            {{
              dataItem.distri_status == 0
                ? "确认派单"
                : dataItem.distri_status == 1
                ? "重新派单"
                : ""
            }}
          </div>
          
        </div>

      </div>
    </div>

    <div class="custom_btn" @click="handleReturn">返回</div>

    <!-- 详情弹窗 -->
    <van-overlay :show="isShow" :lock-scroll="false" z-index="100001">
      <div class="custom_popup">
        <div class="custom_head flex-rowc">选择跑腿业务员</div>
        <div class="custom_popup_wrap">
          <van-radio-group v-model="deliveryStaffOpenid">
            <van-radio
              v-for="(item, index) in adminUserList"
              :key="index"
              :name="item.openid"
              >{{ item.manname }}</van-radio
            >
          </van-radio-group>
        </div>
        <div class="custom_footer flex-between">
          <div class="btn flex-rowc" @click="isShow = false">取消</div>
          <div class="btn query flex-rowc" @click="handleQueryDelivery">
            确认
          </div>
        </div>
      </div>
    </van-overlay>

    <van-image-preview
      v-model="isImggeShow"
      :images="dataItem.givepicArr"
      :startPosition="startPosition"
    >
    </van-image-preview>
  </div>
</template>
  
<script>
import {
  getParkOrderDetail,
  getParkDelivery,
  getAdminUserList,
  getToken,
  getParkOrderDel,
  getParkOrderDispatch,
} from "../../api/api";
export default {
  name: "pDetail",
  data() {
    return {
      isImggeShow: false,
      startPosition: 0,
      isShow: false,
      popupSrc: "",
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      pickupInfo: "", // 取餐信息
      deliveryInfo: "", // 送餐信息
      order_id: "", // 订单id
      token: "", // token

      returncheck: 1,

      adminUserList: [], // 业务员信息

      // 订单分配人员信息
      distriInfo: {},
      // 跑腿业务信息
      getInfo: {},
      // 分配业务员
      deliveryParams: {
        order_id: "",
        delivery_staff_id: "",
        current_location: "",
      },
      // 选中分配人员openid
      deliveryStaffOpenid: "",

      isSubmitting: false, // 是否正在提交
    };
  },
  created() {
    let { id } = this.$route.params;
    this.order_id = id;
    this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getParkOrderDetail();
    this.getAdminUserList();
  },
  methods: {
    // 刷新 token 的方法
    async refreshToken() {
      try {
        const res = await getToken();
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.token = res.data.token;
        } else {
          throw new Error(res.message || "获取 token 失败");
        }
      } catch (error) {
        this.$toast.fail(error.message || "获取 token 失败，请稍后重试");
        throw error;
      }
    },

    // 查看跑腿订单详情
    async getParkOrderDetail() {
      try {
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        let params = {
          order_id: this.order_id,
          token: this.token,
        };
        let res = await getParkOrderDetail(params);
        if (!res.id && res.error_code == 1) {
          await this.refreshToken();
          params.token = this.token;
          res = await getParkOrderDetail(params);
        }
        this.dataItem = res;
        // 订单分配人员信息
        res.delivery_list.forEach((v) => {
          if (v.isdel == 0) {
            this.distriInfo = v;
            this.deliveryStaffOpenid = v.delivery_staff_id;
          } else {
            this.distriInfo = {};
            this.deliveryStaffOpenid = "";
          }
        });
        // 跑腿业务信息
        res.get_list.forEach((v) => {
          if (v.isdel == 0) {
            this.getInfo = v;
          } else {
            this.getInfo = {};
          }
        });
        res.givepicArr = res.givepic ? res.givepic.split(",") : [];
        this.deliveryParams.order_id = res.order_id;
        this.deliveryParams.current_location = res.yuanqu;
        this.$toast.clear();
      } catch (error) {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    // 获取业务员信息
    async getAdminUserList() {
      try {
        let params = {
          token: this.token,
          pageindex: 1,
          pagesize: 120,
          keyword: "",
          role: 1, // 职能身份 =1=综合服务人员 2=取餐员 3=送餐员 4=点位服务人员 5=派单管理员 6=跑腿业务派单管理员
        };
        let res = await getAdminUserList(params);
        if (!res.list && res.error_code == 1) {
          await this.refreshToken();
          params.token = this.token;
          res = await getAdminUserList(params);
        }
        this.adminUserList = res.list;
      } catch (error) {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    // 业务员分配
    async getParkDelivery() {
      try {
        let params = {
          token: this.token,
          ...this.deliveryParams,
        };
        let res = await getParkDelivery(params);
        if (res.error_code == 1) {
          await this.refreshToken();
          params.token = this.token;
          res = await getParkDelivery(params);
        }
        if (res.error_code == 0) {
          await new Promise((resolve) => setTimeout(resolve, 200));
          this.getParkOrderDispatch();
          this.isSubmitting = false;
        } else {
          throw new Error(res.message || "取餐失败");
        }
      } catch (error) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },
    // 业务员分配-指派管理员
    async getParkOrderDispatch() {
      try {
        let params = {
          token: this.token,
          order_id: this.order_id,
          get_staff_id: this.userInfo.openid,
          jie_staff_id: this.deliveryParams.delivery_staff_id,
        };
        let res = await getParkOrderDispatch(params);
        if (res.error_code == 1) {
          await this.refreshToken();
          params.token = this.token;
          res = await getParkOrderDispatch(params);
        }
        if (res.error_code == 0) {
          await new Promise((resolve) => setTimeout(resolve, 500));
          this.getParkOrderDetail();
          this.isSubmitting = false;
        } else {
          throw new Error(res.message || "取餐失败");
        }
      } catch (error) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },

    // 重新派单
    async getParkOrderDel() {
      try {
        let params = {
          token: this.token,
          order_id: this.dataItem.order_id,
        };
        let res = await getParkOrderDel(params);
        if (res.error_code == 1) {
          await this.refreshToken();
          params.token = this.token;
          res = await getParkOrderDel(params);
        }
        if (res.error_code == 0) {
          await new Promise((resolve) => setTimeout(resolve, 500));
          this.getParkOrderDetail();
          this.isSubmitting = false;
        } else {
          throw new Error(res.message || "取餐失败");
        }
      } catch (error) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },

    // 派单-重新派单
    handleSubmit() {
      if (this.isSubmitting) return;

      let { dataItem, deliveryParams } = this;
      // server_state 服务进度 1-待取件 2-已取件 3-送件中 4-已送达
      if (dataItem.server_state >= 2) return;
      // distri_status 分配状态 1-已分配 2-待分配
      if (dataItem.distri_status == 1) {
        this.getParkOrderDel();
      } else {
        if (!deliveryParams.delivery_staff_id) {
          this.$toast("请选择业务员");
          return;
        }
        this.isSubmitting = true;

        this.$toast.loading({
          message: "分配中...",
          forbidClick: true,
        });
        this.getParkDelivery();
      }
    },

    // 确认分配人员
    handleQueryDelivery() {
      let { deliveryStaffOpenid, adminUserList } = this;
      if (deliveryStaffOpenid == "") {
        this.$toast("请选择业务员");
        return;
      }
      adminUserList.forEach((v) => {
        if (v.openid == deliveryStaffOpenid) {
          this.deliveryParams.delivery_staff_id = v.openid;
          this.distriInfo.delivery_staff_name = v.manname;
          this.isShow = false;
        }
      });
    },

    // 预览图片
    handlePreview(index) {
      this.isImggeShow = true;
      this.startPosition = index;
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding: 40px 0 300px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 30px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .con {
        &.red {
          color: #ff0000;
        }
      }
      .block_one {
        font-size: 30px;
        margin-bottom: 65px;
        .column {
          .label {
            min-width: 120px;
          }
        }
      }
      .block_two {
        margin-bottom: 65px;
      }
      .column_img {
        flex-wrap: wrap;
        .cloumn_item {
          width: calc((100% - 60px) / 3);
          &:nth-child(3n-1) {
            margin: 0 30px;
          }
        }
      }
      .btn {
        margin-bottom: 60px;
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          min-width: 170px;
          flex-shrink: 0;
          &.tit {
            margin-bottom: 10px;
          }
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
        .select_box {
          margin-top: 20px;
          width: 100%;
          flex-shrink: 0;
          p {
            flex: 1;
          }
          .iconfont {
            font-size: 38px;
          }
        }
      }
      .phone-icon {
        margin-left: 30px;
        color: #040000;
        span {
          font-size: 38px;
          font-weight: bold;
        }
      }
    }
  }
  .custom_popup {
    width: 650px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);
    border-radius: 35px;
    background: #ffffff;
    .custom_close {
      position: fixed;
      right: 0;
      top: -70px;
      .iconfont {
        font-size: 52px;
        color: #fff;
        // font-weight: bold;
      }
    }
    .custom_head {
      height: 120px;
      font-size: 30px;
    }
    .custom_popup_wrap {
      overflow-y: scroll;
      height: 45vh;
      padding: 0 40px;
      font-size: 24px;
      .van-radio {
        margin-bottom: 10px;
      }
    }
    .custom_footer {
      height: 100px;
      font-size: 30px;
      border-top: 1px solid #ccc;
      .btn {
        flex: 1;
        height: 100%;
        &.query {
          border-left: 1px solid #ccc;
          color: red;
        }
      }
    }
  }
  .custom_btn {
    &.isDisabled {
      background: #979797;
    }
  }
}
</style>